import { render } from "./footer.vue?vue&type=template&id=2b987ece&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=2b987ece&scoped=true&lang=scss"
import "./footer.vue?vue&type=style&index=1&id=2b987ece&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b987ece"]])

export default __exports__